import type { PropsWithChildren } from "react"
import clsx from "clsx"

import type { PropsWithClassName } from "~/@types/generics"

import * as css from "./styles.css"

type StyledWysiwygProps = PropsWithChildren<PropsWithClassName<{ theme?: "small" | "default" }>>

function StyledWysiwyg({ className, children, theme = "default" }: StyledWysiwygProps) {
  return children ? <div className={clsx(css.StyledWysiwyg, css.Theme[theme], className)}>{children}</div> : null
}

export { StyledWysiwyg, type StyledWysiwygProps }
